module.exports = __webpack_public_path__ + "media/images/gallery/constellations/hydra/hya_vis-82bde6bfa7c8fde45f1941ad33e1bff6.jpg";